import type { AnimationConfig, Item, Section, SiteConfig } from './types'

export const cn = (...values: Array<string | false | null | undefined>) => values.filter(Boolean).join(' ')
export const itemsOf = (section: Section) => (section.content.items ?? []) as Item[]
export const contentString = (section: Section, field: string) => String(section.content[field] ?? '')

export const sanitizeUrl = (value: string): string => {
  const trimmed = value.trim()
  if (trimmed.startsWith('/') || trimmed.startsWith('#')) return trimmed
  try { const url = new URL(trimmed); return ['https:', 'mailto:', 'tel:'].includes(url.protocol) ? trimmed : '#' } catch { return '#' }
}

export const animationStyle = (config: AnimationConfig): React.CSSProperties => ({
  '--anim-duration': `${config.duration}s`, '--anim-delay': `${config.delay}s`, '--anim-distance': `${config.intensity}px`,
} as React.CSSProperties)

export const validateSiteShape = (value: unknown): value is SiteConfig => {
  if (!value || typeof value !== 'object') return false
  const site = value as Partial<SiteConfig>
  return site.version === 1 && !!site.theme && Array.isArray(site.navigation) && Array.isArray(site.sections) && site.sections.length <= 40
}

export const sectionLabel: Record<string, string> = { hero: 'Hero', content: 'Content block', services: 'Services', 'pixel-swap': 'Pixel Swap', gallery: 'Gallery', stats: 'Statistics', 'scroll-expand': 'Scroll Expand', testimonials: 'Testimonials', hours: 'Opening hours', blog: 'Blog', faq: 'FAQ', cta: 'Call to action' }
